module.exports = __webpack_public_path__ + "i18n/it.d3d0e500e1b1dcac1c7faaf3a7ffb1a9.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1856
// module chunks = 0